import { render, staticRenderFns } from "./customElement.vue?vue&type=template&id=cda46c96&scoped=true"
import script from "./customElement.vue?vue&type=script&lang=js"
export * from "./customElement.vue?vue&type=script&lang=js"
import style0 from "./customElement.vue?vue&type=style&index=0&id=cda46c96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda46c96",
  null
  
)

export default component.exports